import React, { ComponentProps, FunctionComponent } from "react";

const PhoneRejectIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M13.9996 10.9843V12.7908C14.0003 12.9585 13.9659 13.1245 13.8986 13.2781C13.8313 13.4318 13.7325 13.5697 13.6087 13.6831C13.4849 13.7965 13.3387 13.8828 13.1795 13.9365C13.0203 13.9903 12.8517 14.0102 12.6843 13.9951C10.8277 13.7938 9.04426 13.1606 7.47734 12.1465C6.01953 11.222 4.78356 9.98843 3.8572 8.53351C2.83752 6.96259 2.20294 5.17405 2.0049 3.31277C1.98982 3.14625 2.00965 2.97843 2.06312 2.81998C2.11659 2.66153 2.20254 2.51592 2.31548 2.39244C2.42843 2.26896 2.5659 2.1703 2.71915 2.10274C2.87239 2.03519 3.03805 2.00022 3.20558 2.00006H5.01565C5.30846 1.99718 5.59233 2.10067 5.81435 2.29122C6.03636 2.48178 6.18138 2.74641 6.22236 3.03578C6.29876 3.61389 6.44044 4.18152 6.64471 4.72785C6.72589 4.94338 6.74346 5.17761 6.69534 5.4028C6.64721 5.62799 6.53542 5.83469 6.3732 5.99841L5.60694 6.76315C6.46585 8.27069 7.71655 9.51891 9.22708 10.3761L9.99334 9.61138C10.1574 9.44948 10.3645 9.3379 10.5901 9.28988C10.8158 9.24185 11.0505 9.25939 11.2664 9.3404C11.8138 9.54427 12.3826 9.68567 12.9619 9.76192C13.2549 9.80318 13.5226 9.95052 13.714 10.1759C13.9053 10.4013 14.007 10.689 13.9996 10.9843Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      stroke: "currentColor",
      d: "M14 2L10.6666 5.33333M10.6666 2L14 5.33333",
    })
  );
};

const ForwardRef = React.forwardRef(PhoneRejectIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
